/* ===========================================================================
   ROCKSOLAR finance page — the payment calculator
   assets/rs-finance.js

   Standard amortisation on an equipment price. The system list comes from
   the finder's data layer (#finder-data), so the prices are the store's own
   and live. Nothing here is a quote: the page around it says so, and this
   file only does arithmetic.
   =========================================================================== */
(function () {
  "use strict";

  var $ = function (id) { return document.getElementById(id); };
  var sel = $("fSys"), amt = $("fAmt"), term = $("fTerm"), apr = $("fApr"), aprVal = $("fAprVal");
  var oPay = $("oPay"), oInt = $("oInt"), oTot = $("oTot"), oFlag = $("oFlag");
  if (!sel || !amt || !term || !apr) { return; }

  var CFG = window.RS_FIN || {};
  var MAX = CFG.shopPayMax || 30000, MIN = CFG.shopPayMin || 35;

  /* ---- the range, from the data layer ---------------------------------- */
  var systems = [];
  try {
    var el = document.getElementById("finder-data");
    var data = el ? JSON.parse(el.textContent) : null;
    if (data && data.systems) {
      systems = data.systems.filter(function (s) { return s.price != null && s.price > 0; })
        .sort(function (a, b) { return a.price - b.price; });
    }
  } catch (e) { systems = []; }

  function money(n, cents) {
    if (n == null || isNaN(n)) { return "—"; }
    return "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 });
  }

  sel.innerHTML = '<option value="">Choose a system, or type an amount</option>' +
    systems.map(function (s) {
      return '<option value="' + s.price + '">' + esc(s.title) + ' — ' + money(s.price, true) + '</option>';
    }).join("");

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---- the arithmetic --------------------------------------------------- */
  function payment(P, aprPct, n) {
    var r = aprPct / 100 / 12;
    if (r === 0) { return P / n; }
    return P * r / (1 - Math.pow(1 + r, -n));
  }

  function render() {
    var P = parseFloat(amt.value), n = parseInt(term.value, 10), a = parseFloat(apr.value);
    aprVal.textContent = a.toFixed(1) + "%";
    if (!P || P <= 0 || !n) {
      oPay.textContent = "—"; oInt.textContent = "—"; oTot.textContent = "—";
      oFlag.hidden = true; return;
    }
    var m = payment(P, a, n), total = m * n, interest = total - P;
    oPay.innerHTML = money(m, true) + " <small>/ month</small>";
    oInt.textContent = money(interest, true);
    oTot.textContent = money(total, true);

    /* Say plainly when the amount is outside what Shop Pay Installments takes,
       rather than let the customer discover it at checkout. */
    if (P > MAX) {
      oFlag.hidden = false;
      oFlag.innerHTML = "<strong>Above the $" + MAX.toLocaleString("en-US") + " Shop Pay Installments limit.</strong> A purchase this size goes through the other route, a business or equipment lender, or a deposit at checkout with the balance financed elsewhere. <a href=\"" + esc(CFG.supportUrl || "/pages/contact-us") + "\">Talk to us</a> before you order.";
    } else if (P < MIN) {
      oFlag.hidden = false;
      oFlag.innerHTML = "<strong>Below the $" + MIN + " minimum</strong> for Shop Pay Installments.";
    } else {
      oFlag.hidden = true;
    }
  }

  sel.addEventListener("change", function () {
    if (sel.value) { amt.value = Math.round(parseFloat(sel.value) * 100) / 100; }
    render();
  });
  amt.addEventListener("input", function () {
    /* Typing an amount detaches it from the dropdown, so the label stays honest. */
    if (sel.value && Math.abs(parseFloat(sel.value) - parseFloat(amt.value)) > 0.005) { sel.value = ""; }
    render();
  });
  term.addEventListener("change", render);
  apr.addEventListener("input", render);

  /* Start on a mid-range real system, if there is one, so the page never
     opens on dashes. */
  if (systems.length) {
    var mid = systems[Math.floor(systems.length / 2)];
    sel.value = String(mid.price);
    amt.value = mid.price;
  }
  render();
}());
